/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'ai-mate.chat-error-banner.description': 'Vaše historie chatu je uložena na 30 dní.',
  'ai-mate.chat-error-banner.title': 'Zahájit nový chat',
  'ai-mate.chat-error.description': 'Zkuste <btn>znovu načíst chat</btn>.',
  'ai-mate.chat-error.rate-limited-description': 'Dosáhli jste maximálního počtu žádostí. Zkuste to znovu později.',
  'ai-mate.chat-error.rate-limited-title': 'Příliš mnoho žádostí',
  'ai-mate.chat-error.rovo-inactive-description':
    'Zdá se, že nástroj Rovo není na vašem webu zapnutý. <link>Nastavení nástroje Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Nástroj Rovo není aktivní',
  'ai-mate.chat-error.title': 'Nejsme si jistí, kde se stala chyba',
  'ai-mate.chat-input.file-close-icon-label': 'Odebrat soubor',
  'ai-mate.chat-input.file-error-icon-label': 'Chyba při načítání souboru',
  'ai-mate.chat-view.chat-item.chat-delete-label': 'Odstranit',
  'ai-mate.chat-view.chat-item.chat-options-for-conversation-button-label': 'Možnosti chatu pro: {conversationName}',
  'ai-mate.chat-view.chat-item.chat-rename-label': 'Přejmenovat',
  'ai-mate.common.ui.expandable-section.collapse': 'Sbalit',
  'ai-mate.common.ui.expandable-section.expand': 'Rozbalit',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.cancel-button-label.non-final': 'Zrušit',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.conversation-not-found-failure-message.non-final':
    'Konverzace, kterou se pokoušíte odstranit, neexistuje.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-button-label.non-final': 'Odstranit',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.delete-conversation-title.non-final':
    'Odstranit konverzaci „{name}“?',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.generic-failure-message.non-final':
    'Při odstraňování konverzace došlo k chybě. Zkuste to znovu.',
  'ai-mate.conversation-assistant.conversation-picker.delete-confirm-modal.modal-body.non-final':
    'Opravdu chcete tuto odstranit tuto konverzaci? Akci nejde vrátit zpět.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.cancel-button-label.non-final': 'Zrušit',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.channel-not-found-error-message.non-final':
    'Kanál, který se pokoušíte upravit, neexistuje.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.edit-name-label.non-final': 'Název',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.generic-error-message.non-final':
    'Při úpravě konverzace došlo k chybě. Zkuste to znovu.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.modal-title.non-final': 'Upravit konverzaci',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.name-is-same-error-message.non-final':
    'Název je stejný jako aktuální název.',
  'ai-mate.conversation-assistant.conversation-picker.edit-modal.save-button-label.non-final': 'Uložit',
  'ai-mate.conversation-list-view.accessible-search-results':
    '{results, plural, one {{results,number} nalezený výsledek} few {{results,number} nalezené výsledky} many {{results,number} nalezeného výsledku} other {{results,number} nalezených výsledků}}',
  'ai-mate.conversation-list-view.back-button.label': 'Zpět',
  'ai-mate.conversation-list-view.close-chat-button.label': 'Zavřít chat',
  'ai-mate.conversation-list-view.header-title': 'Historie chatu',
  'ai-mate.conversation-list-view.new-chat-button.label': 'Nový chat',
  'ai-mate.conversation-list-view.no-chat': 'Žádné výsledky',
  'ai-mate.conversation-list-view.search-input.placeholder': 'Vyhledat chaty',
  'ai-mate.expander.hide-details': 'Skrýt podrobnosti',
  'ai-mate.expander.show-details': 'Zobrazit více podrobností',
  'ai-mate.main-chat.close-chat-panel-button-label': 'Zavřít chat',
  'ai-mate.main-chat.maximize-chat-button-label': 'Celá obrazovka',
  'ai-mate.main-chat.minimize-chat-button-label': 'Obnovit zobrazení',
  'ai-mate.main-chat.new-chat-button-label': 'Nové',
  'ai-mate.main-chat.new-chat-button-label-full-screen': 'Nový chat',
  'conversation-assistant-button.rovo-chat-label': 'Chat Rovo',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': 'Odeslat',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': 'Zeptejte se na to AI.',
  'highlight-actions.rovo-chat-explain-option.text': 'Vysvětlit',
  'highlight-actions.rovo-chat-explain-prompt':
    'Vysvětlete to přeformulováním a přidáním dalších podrobností, ale používejte velmi jednoduchý jazyk a krátké věty a uveďte příklady nebo definice veškeré technické terminologie používané v původní formulaci.',
  'highlight-actions.rovo-chat-find-resources-option.text': 'Najít zdroje',
  'highlight-actions.rovo-chat-find-resources-prompt':
    'Najděte v rámci znalostí organizace pouze takové zdroje, které podporují učiněná prohlášení.',
  'highlight-actions.rovo-chat-give-examples-option.text': 'Uvést příklady',
  'highlight-actions.rovo-chat-give-examples-prompt':
    'Uveďte příklady ze zdrojů organizace nebo veřejných znalostí. Pokud neexistují žádné zdroje, které byste mohli poskytnout, zkuste uvést metaforický příklad, který by mohl pomoci lépe tomu porozumět.',
  'highlight-actions.rovo-chat-give-feedback-option.text': 'Poskytnout zpětnou vazbu',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    'Poskytněte zpětnou vazbu tím, že zkontrolujete formulaci. Poskytněte komentář k výběru slov, gramatice, interpunkci. Buďte pozitivní a energičtí, ale vždy uveďte alespoň jednu věc, kterou by šlo zlepšit nebo změnit.',
  'highlight-actions.rovo-chat-more-options.tooltip': 'Doporučení chatu',
  'highlight-actions.rovo-chat-open-chat.tooltip': 'Otevřít chat',
  'highlight-actions.rovo-chat-summarize-option.text': 'Shrnout',
  'highlight-actions.rovo-chat-summarize-prompt':
    'Zvýrazněte klíčové body. Zaměřte se na základní informace a vylučte zbytečné podrobnosti. Poskytněte stručný přehled v jediném odstavci.',
  'highlight-actions.rovo-chat.ask-in-chat-button-text': 'Zeptat se v chatu',
  'highlight-actions.rovo-chat.placeholder-prompt': 'Zeptejte se na to.',
  'horizontal-scroll-container.scroll-left': 'Posunout doleva',
  'horizontal-scroll-container.scroll-right': 'Posunout doprava',
  'rovo-chat.deep-research-spotlight.description':
    'Zapněte hluboký výzkum a zadejte výzvu. Rovo vytvoří plán, provede výzkum a vygeneruje úplnou zprávu.',
  'rovo-chat.deep-research-spotlight.dismiss': 'Zavřít',
  'rovo-chat.deep-research-spotlight.heading': 'Představujeme hluboký výzkum v nástroji Rovo',
  'rovo-chat.file-upload-dropzone.drag-drop-message': 'Přetažením přidejte kontext.',
  'rovo-chat.message-file.icon-label': 'Soubor',
  'rovo-chat.search-input.screen-reader-prompt':
    'Při zadání libovolného znaku do tohoto pole se aktualizují níže uvedené výsledky vyhledávání.',
};
